import {
  Container,
  HStack,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
  VStack,
  Image,
  Center,
  Link,
  Icon,
  useClipboard,
  Box,
  BoxProps,
} from '@chakra-ui/react';
import CoinEx from '../assets/coinex.png';
import GateIo from '../assets/gateio.png';
import Uniswap from '../assets/uniswap.png';
import Ethereum from '../assets/ethereum.png';
import { FaCopy, FaLink } from 'react-icons/fa6';
import { addresses, shortAddress } from '../utils/contracts';
import { ReactNode } from 'react';

export default function GetXEDModal({ children, ...props }: { children: ReactNode } & BoxProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { hasCopied, onCopy } = useClipboard(addresses.token);

  return (
    <>
      <Box onClick={onOpen} {...props}>
        {children}
      </Box>
      <Modal isOpen={isOpen} onClose={onClose} size="full">
        <ModalOverlay />
        <ModalContent bg="blackAlpha.100" backdropFilter="blur(5px)" p="20">
          <Container maxW="container.lg">
            <HStack w="100%" justify="space-between">
              <Text
                w="100%"
                fontSize="2xl"
                fontFamily="uniwars"
                fontWeight="bold"
                color="brand.500"
              >
                Get $XED
              </Text>

              <ModalCloseButton position="relative" />
            </HStack>

            <VStack w="100%" align="start" spacing="4" pt="5">
              <Text fontSize="sm" fontWeight="semibold">
                Get $XED today and contribute to the success of Exeedme DAO and its growing
                ecosystem
              </Text>

              <HStack w="100%" spacing="4">
                <HStack
                  as={Link}
                  href="https://www.coingecko.com/en/coins/exeedme"
                  target="_blank"
                  color="gray.100"
                  _hover={{ color: 'white' }}
                  spacing="1"
                >
                  <Text fontSize="sm">View on CoinGecko</Text>
                  <Icon as={FaLink} fontSize="xs" />
                </HStack>
                <HStack
                  as={Link}
                  href="https://coinmarketcap.com/currencies/exeedme/"
                  target="_blank"
                  cursor="pointer"
                  color="gray.100"
                  _hover={{ color: 'white' }}
                  spacing="1"
                >
                  <Text fontSize="sm">View on CoinMarketCap</Text>
                  <Icon as={FaLink} fontSize="xs" />
                </HStack>
              </HStack>
            </VStack>

            <VStack w="100%" align="start" pt="10" pb="5" spacing="4">
              <Text fontSize="md" fontWeight="semibold">
                Contract Address
              </Text>

              <HStack>
                <Image src={Ethereum} alt="Ethereum" boxSize="5" />
                <Text fontSize="sm">{shortAddress(addresses.token)}</Text>
                <HStack
                  spacing="1"
                  onClick={onCopy}
                  cursor="pointer"
                  bg="whiteAlpha.200"
                  _hover={{ bg: 'whiteAlpha.300' }}
                  py="1"
                  px="2"
                  borderRadius="lg"
                >
                  <Icon as={FaCopy} fontSize="xs" />
                  <Text fontSize="sm">{hasCopied ? 'Copied...' : 'Copy'}</Text>
                </HStack>
              </HStack>
            </VStack>

            <VStack w="100%" align="start" py="10" spacing="4">
              <Text fontSize="md" fontWeight="semibold">
                Available On
              </Text>

              <HStack w="100%" spacing="6">
                <Text fontSize="sm" fontFamily="uniwars" fontWeight="semibold" color="brand.500">
                  CEX
                </Text>
                <Stack w="100%" direction={{ base: 'column', md: 'row' }} spacing="2">
                  <Center
                    _hover={{ bg: 'whiteAlpha.100' }}
                    p="5"
                    cursor="pointer"
                    as={Link}
                    href="https://www.coinex.com/en/exchange/xed-usdt"
                    target="_blank"
                  >
                    <Image src={CoinEx} alt="CoinEx" h="6" />
                  </Center>
                  <Center
                    _hover={{ bg: 'whiteAlpha.100' }}
                    p="5"
                    cursor="pointer"
                    as={Link}
                    href="https://www.gate.io/trade/XED_USDT"
                    target="_blank"
                  >
                    <Image src={GateIo} alt="GateIo" h="6" />
                  </Center>
                </Stack>
              </HStack>
              <HStack w="100%" spacing="6">
                <Text fontFamily="uniwars" fontSize="sm" fontWeight="semibold" color="brand.500">
                  DEX
                </Text>
                <Stack w="100%" direction={{ base: 'column', md: 'row' }} spacing="2">
                  <Center
                    _hover={{ bg: 'whiteAlpha.100' }}
                    p="5"
                    cursor="pointer"
                    as={Link}
                    href={`https://app.uniswap.org/swap?inputCurrency=ETH&outputCurrency=${addresses.token}`}
                    target="_blank"
                  >
                    <Image src={Uniswap} alt="Uniswap" h="6" />
                  </Center>
                </Stack>
              </HStack>
            </VStack>
          </Container>
        </ModalContent>
      </Modal>
    </>
  );
}
